import type { Routine } from "./routine.types";

import "./RoutineCard.css";

type Props = {
  routine: Routine;
  onToggle: (id: string) => void;
  onEdit: (routine: Routine) => void;
  onDelete: (id: string) => void;
};

export function RoutineCard({
  routine,
  onToggle,
  onEdit,
  onDelete,
}: Props) {
  return (
    <article
      className={
        routine.completed
          ? "routine-card routine-card--completed"
          : "routine-card"
      }
    >
      <button
        className="routine-card__check"
        type="button"
        aria-label={
          routine.completed
            ? `Mark ${routine.title} incomplete`
            : `Mark ${routine.title} complete`
        }
        onClick={() => onToggle(routine.id)}
      >
        {routine.completed ? "✓" : ""}
      </button>

      <span
        className="routine-card__icon"
        aria-hidden="true"
      >
        {routine.icon}
      </span>

      <div className="routine-card__content">
        <strong>{routine.title}</strong>

        <small>
          {routine.isRoutine
            ? routine.repeatRule
            : new Date(
                routine.dueAt,
              ).toLocaleString()}
        </small>

        {routine.note && (
          <p>{routine.note}</p>
        )}

        {routine.location && (
          <span className="routine-card__location">
            ⌖ {routine.location}
          </span>
        )}
      </div>

      <div className="routine-card__actions">
        <button
          type="button"
          onClick={() => onEdit(routine)}
        >
          Edit
        </button>

        <button
          type="button"
          onClick={() => {
            if (
              window.confirm(
                `Delete "${routine.title}"?`,
              )
            ) {
              onDelete(routine.id);
            }
          }}
        >
          Delete
        </button>
      </div>
    </article>
  );
}